export default __webpack_public_path__ + "static/media/leatherShoes.c8aa464d.svg";